export default {
  'menu.workbench': '工作台',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.project-center': '项目管理',
  'menu.system': '系统设置',
  'menu.system.menu': '菜单管理',
  'menu.system.user': '用户管理',
  'menu.system.role': '角色管理',
  'menu.system.permissions': '权限管理',
  'menu.system.dictionary': '数据字典',
  'menu.system.ai-model-binding': '模型绑定',
  'menu.template-center': '模板中心',
  'menu.template-center.detail': '模板详情',
  'menu.project-center.workbench': '工作台',
  'menu.project-center.project-overview': '项目总览',
  'menu.project-center.project-space': '项目空间',
  'menu.project-center.my-tasks': '我的任务',
  'menu.project-center.my-projects': '我的项目',
  'menu.project-center.dashboard': '问题中心',
  'menu.project-center.boards': '全局看板',
  'menu.project-center.gantt': '全局甘特图',
  'menu.project-center.projects': '项目列表',
  'menu.project-center.resources': '资源中心',
  'menu.project-center.calendar': '日历',
  'menu.project-center.risks': '风险识别',
  'menu.project-center.analytics': '统计分析',
  'menu.project-center.project-detail': '项目工作区',
  'menu.project-center.project-detail.overview': '概览',
  'menu.project-center.project-detail.kanban': '任务',
  'menu.project-center.project-detail.gantt': '进度',
  'menu.project-center.project-detail.delivery': '文档资料',
  'menu.project-center.project-detail.acceptance': '验收',
  'menu.project-center.project-detail.communication': '沟通',
  'menu.project-center.project-detail.members': '项目成员',
  'menu.project-center.project-detail.work-hours': '统计',
  'menu.project-center.project-detail.issues': '风险问题',
  'menu.project-center.project-detail.report': '项目汇报',
  'menu.project-center.project-detail.review': '复盘',
  'menu.project-center.project-detail.activities': '动态',
  'menu.login': '登录',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.workbench': '回到工作台',
  'menu.account.tenantManagement': '企业管理',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
};
